import React from 'react'

const WomanWalk = () => (
  <svg
    width="198"
    height="254"
    viewBox="0 0 198 254"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M171.517 42.5073C194.303 71.7447 202.521 111.872 194 147.814C185.479 183.756 160.224 215.416 131.542 222.473C102.861 229.531 70.7451 211.989 46.695 194.144C22.655 176.247 6.62382 158.099 1.68271 137.18C-3.2584 116.261 2.94377 92.6171 16.8554 65.4427C30.767 38.2682 52.458 7.4204 81.9383 1.22489C111.429 -5.03052 148.731 13.2699 171.517 42.5073Z"
      fill="#F3F5F8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.099 60.0856C106.906 64.4944 98.1023 81.1843 94.1494 84.1889C90.1966 87.1935 79.5723 79.9565 79.4259 76.2399C79.2795 72.5232 93.291 55.6802 100.099 60.0856Z"
      fill="#646361"
    />
    <rect
      x="21.2236"
      y="74.5298"
      width="149.731"
      height="71.5379"
      fill="#E4E9EF"
    />
    <path
      d="M96.0878 112.794L21.2225 74.5296L170.953 74.5296L96.0878 112.794Z"
      fill="#EDEFF3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M93.6931 45.4187C93.7563 48.7959 95.1671 54.4425 95.2303 58.6183C95.2935 62.7941 92.4054 67.1496 91.5469 69.2358C90.6885 71.3221 95.3501 78.0766 95.3501 78.0766L105.848 72.2005L105.405 53.767C105.405 53.767 93.6332 42.0414 93.6931 45.4187Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M103.18 18.77C115.571 18.77 120.129 29.494 120.322 36.4282C120.322 40.6639 119.104 44.7732 119.989 47.9841C119.923 55.9431 128.527 63.5195 128.527 75.844C128.527 97.8044 111.448 95.0427 102.654 95.3622C93.8597 95.6816 101.04 74.9988 101.17 71.016C101.3 67.0331 101.466 58.0393 101.722 54.3194C101.978 50.5994 91.484 43.0396 91.6104 39.7655C91.7369 36.4914 85.5912 19.3489 103.18 18.77Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M161.531 225.658L167.135 229.458L172.205 223.758L167.151 218.69L161.531 225.658Z"
      fill="#B3B3B3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62.9058 237.513L60.5234 243.296L67.3478 246.573L70.0563 241.113L62.9058 237.513Z"
      fill="#B3B3B3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M124.431 112.035C127.393 114.857 128.923 158.618 128.504 167.393C130.723 172.327 167.767 218.76 167.767 218.76L161.584 226.539C161.584 226.539 111.052 187.942 108.347 183.537C105.642 179.131 76.9601 137.473 124.431 112.035Z"
      fill="#C01414"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M90.9493 120.114C88.567 126.746 79.0308 164.478 77.3704 175.155C75.7101 185.833 62.3408 237.659 62.3408 237.659L70.0103 241.809C70.0103 241.809 129.899 135.22 124.04 115.732C118.18 96.2439 93.335 113.486 90.9493 120.114Z"
      fill="#D62929"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M90.0205 36.9805C90.6161 28.5424 96.4523 22.0807 103.054 22.5465C109.655 23.0123 114.526 30.2327 113.931 38.6708C113.335 47.109 107.499 53.5674 100.894 53.1049C94.2895 52.6424 89.4349 45.4187 90.0205 36.9805Z"
      fill="#B3B3B3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M103.916 57.8197C122.762 53.2945 129.087 104.07 125.34 115.985C121.986 124.6 98.9013 127.757 89.8243 123.415C86.3406 120.653 78.0522 64.0286 103.916 57.8197Z"
      fill="#4D4D4D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M106.737 88.0387C107.489 92.7702 108.84 108.335 109.066 111.996C109.292 115.656 104.707 136.951 103.13 139.872C104.707 142.048 109.365 145.958 109.365 145.958C109.365 145.958 118.083 128.1 121.487 113.792C122.562 109.277 119.208 87.7259 118.605 85.999C118.003 84.2721 105.981 83.3039 106.737 88.0387Z"
      fill="#B3B3B3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.1405 245.575L64.6202 254L41.4053 244.863L42.9092 240.963L60.3944 242.042L68.1405 245.575Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M171.621 222.633L178.832 228.23L163.968 248.257L160.598 245.788L166.201 229.191L171.621 222.633Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.1194 23.009C96.1827 26.5394 98.3887 35.8825 110.244 40.7272C117.627 43.7451 117.048 40.7272 117.048 40.7272L112.683 24.2867L106.135 20.4403C106.135 20.4403 96.0562 19.4787 96.1194 23.009Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M107.187 41.1264C107.187 40.4801 107.378 39.8484 107.737 39.3111C108.096 38.7738 108.607 38.355 109.204 38.1077C109.801 37.8603 110.458 37.7956 111.091 37.9217C111.725 38.0478 112.307 38.359 112.764 38.8159C113.221 39.2729 113.533 39.8551 113.659 40.4889C113.785 41.1228 113.72 41.7797 113.473 42.3768C113.225 42.9738 112.807 43.4841 112.269 43.8432C111.732 44.2022 111.1 44.3938 110.454 44.3938C109.587 44.3938 108.756 44.0496 108.144 43.4368C107.531 42.8241 107.187 41.993 107.187 41.1264Z"
      fill="#B3B3B3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M109.159 63.3697C117.184 62.1885 121.59 80.5355 120.605 85.4034C117.737 88.7507 109.874 89.9619 104.301 89.15C101.745 86.4548 101.137 64.5476 109.159 63.3697Z"
      fill="#646361"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M99.8193 46.0742H109.801V60.3185C108.261 61.6894 102.681 63.0703 99.8193 60.1488V46.0742Z"
      fill="#B3B3B3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M95.2594 44.3676C96.0004 44.3735 96.6212 44.7303 96.7869 45.1763C96.9112 45.5112 97.2835 45.682 97.6184 45.5576C97.9533 45.4333 98.1241 45.061 97.9997 44.726C97.5667 43.5598 96.272 43.0818 95.2696 43.0739C94.746 43.0697 94.1901 43.1863 93.75 43.4864C93.2813 43.8061 92.9702 44.3229 93.0057 44.9874C93.0248 45.3442 93.3295 45.6179 93.6862 45.5988C94.043 45.5797 94.3167 45.2751 94.2976 44.9183C94.2885 44.7472 94.348 44.6446 94.4789 44.5553C94.6384 44.4465 94.9113 44.3648 95.2594 44.3676Z"
      fill="#1F161E"
    />
    <ellipse
      rx="0.534512"
      ry="1.06902"
      transform="matrix(-0.0629482 0.998017 0.998017 0.0629482 96.1915 35.8677)"
      fill="#0D0D0D"
    />
    <path
      d="M97.587 40.258C96.5762 40.258 95.7569 40.0345 95.7569 39.7589C95.7569 39.4833 96.5762 39.2598 97.587 39.2598C98.5977 39.2598 99.417 39.4833 99.417 39.7589C99.417 40.0345 98.5977 40.258 97.587 40.258Z"
      fill="#FA9E9F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M91.9849 37.6467C92.1984 37.761 92.2817 38.0323 92.171 38.2526C92.1382 38.3178 92.0966 38.3957 92.0494 38.484C91.8319 38.891 91.4953 39.5207 91.3589 40.1579C91.2774 40.5383 91.2845 40.8552 91.3873 41.0938C91.4808 41.311 91.6846 41.5354 92.161 41.6771C92.392 41.7458 92.5254 41.9948 92.4588 42.2334C92.3923 42.4719 92.151 42.6096 91.92 42.5409C91.2514 42.3421 90.8108 41.968 90.5916 41.459C90.3817 40.9714 90.4079 40.4345 90.5086 39.9639C90.6765 39.1798 91.0993 38.3957 91.3081 38.0083C91.346 37.9379 91.377 37.8806 91.398 37.8388C91.5087 37.6184 91.7715 37.5324 91.9849 37.6467Z"
      fill="#1F161E"
    />
  </svg>
)

export default WomanWalk
